module.exports = __webpack_public_path__ + "static/img/s3.6496102a.png";